import { call, put, select, takeEvery } from 'redux-saga/effects'
import { startAsyncValidation, stopAsyncValidation } from 'redux-form/immutable'

import api from 'api'

import { NAME, LEADER_SIGNUP } from './constants'
import actions from './actions'
import selector from './selectors'

export function* onSubmit({ payload }) {
  const { signupType } = yield select(selector)
  const source = signupType === LEADER_SIGNUP ? 'leader' : 'parent'
  yield put(startAsyncValidation(NAME))
  try {
    const { email, password } = payload
    yield call([api.user, 'signup'], email, password, source)
    yield put(stopAsyncValidation(NAME))
    yield put(actions.set({ success: true }))
  } catch ({ response }) {
    console.error(response)
    yield put(stopAsyncValidation(NAME, response.data))
  }
}

export default function*() {
  yield takeEvery(actions.submit.toString(), onSubmit)
}



// WEBPACK FOOTER //
// ../source/views/Signup/sagas.js